import AlertComponent from './Confirm.vue'
import { createVNode, render } from 'vue'

const container = document.createElement('div')
container.style.zIndex = 1
document.body.appendChild(container)

const Confirm  = function (title, text) {
    return new Promise((resolve, reject) => {
        const cancelCallback = () => {
            render(null, container)
            reject()
        }

        const successCallback = () => {
            render(null, container)
            resolve()
        }

        const vn = createVNode(AlertComponent, {title, text, successCallback, cancelCallback})
        render(vn, container)
    })
}

const confirm = {
    install(app) {
        app.config.globalProperties.$confirm = Confirm
    }
}

export default confirm